import PropTypes from 'prop-types';
import React from 'react';
import { Wrapper, Message, ErrorMessage, SuccessMessage } from './ToastMessengerStyles';

const ToastMessengerView = ({ messages }) => (
  <Wrapper>
    {messages.map(({ type, message }, index) => {
      switch (type) {
        case 'error':
          return <ErrorMessage key={index}>{message}</ErrorMessage>;
        case 'success':
          return <SuccessMessage key={index}>{message}</SuccessMessage>;
        default:
          return <Message key={index}>{message}</Message>;
      }
    })}
  </Wrapper>
);

ToastMessengerView.propTypes = {
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      message: PropTypes.string,
    }),
  ).isRequired,
};

export default ToastMessengerView;
